<template>
  <div class="background">
    <div v-if="pageIsLoaded" class="settings">
      <head-title class="head-title">Settings</head-title>

      <div class="settings-item settings-item__security">
        <div class="settings__title settings__title_security">
          Security
        </div>

        <div class="settings__column">

          <div class="settings-email">
            <div class="settings-email__group settings__group">
              <div class="settings-email__label settings__label">Email</div>
              <div class="settings-email__value settings__value">
                <span :title="settings.email" class="settings__email">
                  {{settings.email}}
                </span>
                <round-btn small class="change-setting"  @click="openEmailChangePopup">
                  <icon-base red>
                    <icon-pencil />
                  </icon-base>
                </round-btn>
              </div>
            </div>
          </div>

          <button-el @click.native="openPasswordChangePopup" left red class="change-password">
            Change password
            <icon-base class="icon-lock" red>
              <icon-lock/>
            </icon-base>
          </button-el>

          <div class="settings-phone">
            <div class="settings-phone__group settings__group">
              <div class="settings-phone__label settings__label">Phone</div>
              <div class="settings-phone__value settings__value">
                <span class="settings-phone__phone-marign" v-if="settings.phone">
                  {{settings.phone}}
                </span>
                <span class="phone-isnt-linked-text" v-else>
                  Phone isn't linked
                </span>
                <round-btn
                  small
                  @click="openPhoneChangePopup"
                  class="change-setting change-phone"
                  :disabled="requestUnlinkPhoneInProgress"
                >
                  <icon-base red>
                    <icon-pencil />
                  </icon-base>
                </round-btn>
                <round-btn
                  small
                  v-if="settings.phone"
                  @click="unlinkPhoneNumber"
                  class="change-setting btn-unlink"
                  :disabled="requestUnlinkPhoneInProgress"
                >
                  <icon-base red>
                    <icon-cross />
                  </icon-base>
                </round-btn>
              </div>
            </div>
          </div>

          <checkbox-el
            id="settings-checkbox"
            @input="changeEmailSubscription"
            :value="settings.emailSubscription"
            class="settings__checkbox"
          >I want to receive emails from Cryptoalerts.com</checkbox-el>
        </div>

        <email-change-popup
          v-if="showEmailChangePopup"
          @closePopup="closeEmailChangePopup"
        />
        <!-- TODO update number on close with success -->
        <phone-change-popup
          v-if="showPhoneChangePopup"
          @closePopupWithNoResult="closePhoneChangePopup"
          @closePopupWithSucccess="updateSettingsAndClosePhonePopup"
        />
        <password-change-popup
          v-if="showPasswordChangePopup"
          @closePopup="closePasswordChangePopup"
        />
      </div>

      <div class="settings-item settings-item__timezone">
        <div class="settings__title">
          Timezone & currency
        </div>
        <div class="settings__column settings__col-row">
          <div class="settings__col">
            <div class="settings__text">
              We&nbsp;need information about your timezone to&nbsp;provide the most accurate information.
            </div>

            <select-box selectFirstByDefault :value="selectedTimezone" @input="changeTimezoneWrapper" :options="timezonesList" class="settings__selectbox"/>
          </div>
          <div class="settings__col">
            <div class="settings__text">
              Choose your primary currency which we&nbsp;should use for calculating all prices:
            </div>
            <radio-el
              class="settings__fiat-radios"
              inlineBigMargins
              :value="settings.currencyCode"
              :radioValues="fiatCurrenciesList"
              @input="changeDefaultFiatCurrency"
            />
          </div>
        </div>
      </div>

      <div class="settings-item settings-item__email-overview">
        <div class="settings__title">
          Email overview
        </div>

        <div class="settings__column">
          <div class="settings__text">
            We&nbsp;will send you a&nbsp;market summary with a&nbsp;short overview of&nbsp;selected currencies. When a&nbsp;currency is&nbsp;added to&nbsp;favorites it&nbsp;is&nbsp;also automatically added to&nbsp;the list of&nbsp;currencies showcased in&nbsp;weekly summary reports. You can customize the list of&nbsp;showcased currencies below.
          </div>

          <radio-el :radioValues="emailSubscriptionOptions" @input="changeEmailSubscriptionFrequency" :value="settings.emailOverviewFrequency" class="settings__radio settings__radio_email-overview" inline></radio-el>

          <!-- TODO impplement when user will be able to login with unconfirmed email -->
          <!-- <red-label class="settings__red-label">
            In order to receive summaries your have to confirm your email
            <button-el class="confirm-btn" red>CONFIRM</button-el>
          </red-label> -->

        <div class="settings-currencies">
          <div class="settings-currencies__group settings__group">
            <div class="settings-currencies__label settings__label">Currencies in reivew</div>
            <div class="settings__value_wrap">
              <div class="settings-currencies__value settings__value settings__value_inline" v-show="settings.subscribedTickers.length">
                <div class="settings__tickers" v-for="item in settings.subscribedTickers" :key="item.id"> {{item.name}} ({{item.symbol}})</div>
              </div>
            </div>
            <round-btn class="change-setting" @click="openCurrenciesPopup" small>
              <icon-base red>
                <icon-pencil />
              </icon-base>
            </round-btn>
          </div>
        </div>

        </div>

        <currencies-modal
          v-if="showCurrenciesModal"
          @close="closeCurrenciesModal"
        />
      </div>

      <!-- <div class="settings-item settings-item__socials">
        <div class="settings__title">
          Social Accounts Links
        </div>

        <div class="settings__column">
          <div class="settings__text">
            If you use the same email address on Google you can connect it to your account with link below and use it for log in. If your email addresses are different, this will create a new CryptoAlerts account that won’t be linked to your previous account. So be carefull. You also can disconnect Google account and still be able to log in with email which were linked to this account.
          </div>

          <div class="settings__socials">

            <div class="social-btn-wrap">
              <div class="social-btn__help-text" :class="{' social-btn_unbind': !bindGoogle, ' social-btn_bind': bindGoogle}">
                <div class="social-text-wrap">
                  <span class="social-btn-text social-btn-text__unbind">Link your</span>
                  <span class="social-btn-text social-btn-text__bind">is linked</span>
                </div>
                <div class="icon-google-logo"></div>
              </div>

              <social-btn :mode="SocialBtnModes.authBtn" class="social-btn" @click="toogleBindGoogle">
                <icon-base red>
                  <icon-google/>
                </icon-base>
              </social-btn>
            </div>

          </div>
        </div >

      </div> -->

      <div class="settings-item settings-item__delete-account">
        <div class="settings__title">
          Delete account
        </div>

        <button-el @click.native="openDeleteAccountModal" left red large class="delete-account-btn">
          Delete account
          <icon-base class="icon-lock" red>
            <icon-lock/>
          </icon-base>
        </button-el>

        <transition name="fade">
          <delete-account-modal
            v-if="showDeleteAccountModal"
            @close="closeDeleteAccountModal"
          />
        </transition>
      </div>

    </div>
    <div v-else class="spinner-container">
      <spinner-el class="spinner" />
    </div>
  </div>
</template>


<script>
/* @flow */
import { mapState, mapActions } from 'vuex';
import SocialBtnModes from 'src/models/SocialBtnModes';
import timezonesList from 'src/models/TimezonesList';
import SocialBtn from 'Uikit/SocialBtn';
import { IconLock, IconPencil, IconGoogle, IconCross } from 'Icons';
import phoneChangePopupLogic from 'src/mixins/phoneChangePopupLogic';
import EmailChangePopup from './EmailChangePopup';
import DeleteAccountModal from './DeleteAccountModal';
import PasswordChangePopup from './PasswordChangePopup';
import CurrenciesModal from './CurrenciesModal';

export default {
  mixins: [
    phoneChangePopupLogic,
  ],
  data: () => ({ // eslint-disable-line
    bindGoogle: false,
    pageIsLoaded: false,
    requestUnlinkPhoneInProgress: false,
    emailSubscriptionOptions: [
      {
        name: 'weekly',
        id: 'weekly',
        value: 'weekly',
        text: 'Weekly summary',
        disabled: false,
      },
      {
        name: 'never',
        id: 'never',
        value: 'never',
        text: 'I don\'t need reports',
        disabled: false,
      },
    ],
    selectedEmailSubscription: null,
    SocialBtnModes,
    showDeleteAccountModal: false,
    showCurrenciesModal: false,
    showEmailChangePopup: false,
    showPasswordChangePopup: false,
  }),
  components: {
    IconLock,
    SocialBtn,
    IconCross,
    IconPencil,
    IconGoogle,
    CurrenciesModal,
    EmailChangePopup,
    DeleteAccountModal,
    PasswordChangePopup,
  },
  computed: {
    ...mapState('userData', ['loginInfo', 'settings']),
    timezonesList: (): any => timezonesList,
    selectedTimezone(): any {
      return timezonesList.find(tz => tz.name === this.settings.timezone); //eslint-disable-line
    },
    fiatCurrenciesList: (): any => [
      {
        name: 'usd',
        id: 'usd',
        value: 'usd',
        text: 'USD',
      },
      {
        name: 'eur',
        id: 'eur',
        value: 'eur',
        text: 'EUR',
      },
    ],
  },
  methods: {
    toogleBindGoogle() {
      this.bindGoogle = !this.bindGoogle;
    },
    ...mapActions('userData', [
      'updateUserSettings',
      'changeEmailSubscriptionFrequency',
      'changeDefaultFiatCurrency',
      'changeEmailSubscription',
      'changeTimezone',
    ]),
    changeTimezoneWrapper(tz: any) {
      this.changeTimezone(tz.name);
    },
    openCurrenciesPopup() {
      this.showCurrenciesModal = true;
    },
    closeCurrenciesModal() {
      this.showCurrenciesModal = false;
      this.updateUserSettings();
    },
    openEmailChangePopup() {
      this.showEmailChangePopup = true;
    },
    closeEmailChangePopup() {
      this.showEmailChangePopup = false;
    },
    openPasswordChangePopup() {
      this.showPasswordChangePopup = true;
    },
    closePasswordChangePopup() {
      this.showPasswordChangePopup = false;
    },
    openDeleteAccountModal() {
      this.showDeleteAccountModal = true;
    },
    closeDeleteAccountModal() {
      this.showDeleteAccountModal = false;
    },
    escapeKeyListener(event: any) {
      if (event.keyCode === 27) {
        this.closeCurrenciesModal();
        this.closeEmailChangePopup();
        this.closePasswordChangePopup();
        this.closeDeleteAccountModal();
      }
    },
    updateSettingsAndClosePhonePopup() {
      this.closePhoneChangePopup();
      this.updateUserSettings();
    },
    unlinkPhoneNumber() {
      if (confirm('Are you sure?')) { // eslint-disable-line no-alert
        this.requestUnlinkPhoneInProgress = true;
        this.$apiService.deletePhone().finally(() => {
          this.updateUserSettings().finally(() => {
            this.requestUnlinkPhoneInProgress = false;
          });
        });
      }
    },
  },
  created() {
    document.addEventListener('keyup', this.escapeKeyListener);
    this.updateUserSettings().then(() => {
      this.pageIsLoaded = true;
    });
  },
  beforeDestroy() {
    document.removeEventListener('keyup', this.escapeKeyListener);
  },
};
</script>

<style lang="scss" scoped>
.spinner {
  margin: auto;
}
.spinner-container {
  margin-top: -$header-height - $footer-height;
}
.background {
  @include background;
}
.settings {
  @include container;
  background: $white-color2;
  border-radius: 5px;
  &__title {
    @include font(17px, $black-color1, 500);
    line-height: 20px;
    width: 23.1%;
    &_security {
      line-height: 25px;
    }
  }
  &__tickers {
    display: inline-block;
    padding-right: 3px;
    &:after {
      content: ',';
    }
    &:last-child {
      &:after {
        display: none;
      }
    }
  }
  &__email {
    max-width: 220px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
  }
  &__text {
    @include font(13px, $black-color1);
    line-height: 22px;
  }
  &__column {
    border-bottom: 1px solid $grey-color3;
    width: 76.3%;
    padding-bottom: 60px;
  }
  &__col-row {
    display: inline-flex;
  }
  &__col {
    width: 320px;
    &:not(:first-child) {
      margin-left: 69px;
    }
  }
  &__selectbox {
    display: inline-block;
    max-width: 419px;
    width: 100%;
    margin-right: 25px;
    margin-top: 12px;
    margin-bottom: 1px;
  }
  &__fiat-radios {
    margin-top: 43px;
    margin-left: 1px;
  }
  &__radio {
    margin-top: 24px;
  }
  &__socials {
    margin-top: 28px;
  }
  &__checkbox {
    margin-top: 17px;
    margin-left: 1px;
  }
  &__value {
    max-width: 640px;
    margin-bottom: 15px;
    background: transparent;
    @include font(13px, $black-color1);
    line-height: 23px;
    &_wrap {
      display: flex;
      align-items: center;
    }
    &_inline {
      display: inline-block;
    }
    > span {
      margin-right: 12px;
    }
  }
  &__label {
    @include font(12px, $grey-color1, 500);
    display: block;
  }
  &__group {
    display: inline-block;
  }
  .change-setting {
    display: inline-flex;
    vertical-align: top;
    margin-top: -3px;
  }
  .change-phone {
    margin-right: 6px;
  }
  .change-password {
    display: inline-block;
    margin-top: 7px;
    max-width: 221px;
    padding: 10px 23px 10px 18px;
    margin-left: 92px;
    .icon-lock {
      margin-right: -3px;
      margin-top: 0px;
    }
  }
  .settings__red-label {
    font-size: 13px;
    max-width: 641px;
    width: 100%;
    margin-bottom: 39px;
    margin-top: 13px;
    letter-spacing: 0.1px;
    padding-right: 15px;
  }
  .confirm-btn {
    margin-top: 2px;
    margin-left: 28px;
  }
}
.settings-phone {
  display: block;
  width: 23%;
  margin-top: 12px;
  &__phone-marign {
    margin-right: 8px;
  }
  &__group {
    max-width: 205px;
    width: 100%;
  }
  &__label {
    margin-bottom: 6px;
  }
}
.settings-currencies {
  &__label {
    margin-bottom: 10px;
  }
  &__group{
    margin-right: 16px;
  }
  &__value {
    margin-right: 18px;
  }
}
.settings-email {
  display: inline-block;
  vertical-align: top;
  width: 33%;
  margin-top: 7px;
  &__group {
    max-width: 270px;
    width: 100%;
  }
  &__label {
    margin-bottom: 5px;
  }
}

.settings-item {
  display: flex;
  flex-direction: row;
  padding: 55px 0 0 30px;
  &:last-child {
    .settings__column {
      border-bottom: none;
    }
  }
  &__email-overview {
    padding-top: 56px;
    .settings__text {
      padding-right: 230px;
      margin-top: -3px;
      line-height: 23px;
    }
    .settings__column {
      padding-bottom: 62px;
    }
  }
  &__delete-account {
    padding-top: 45px;
    padding-bottom: 44px;
  }
  &__socials {
    .settings__text {
      padding-right: 100px;
    }
  }
  &__timezone {
    .settings__column {
      margin-top: -2px;
      .settings__col:last-child {
        .settings__text {
          max-width: 260px;
        }
      }
    }
  }
}

.head-title {
  padding: 31px 30px;
  border-bottom: 1px solid $grey-color3;
}
.social-btn {
  vertical-align: middle;
  &__help-text {
    display: inline-block;
    width: 203px;
    margin-top: 21px;
    transition: $transition;
  }
  &_bind {
    .social-btn-text__unbind {
      opacity: 0;
    }
    .social-btn-text__bind {
      transition-delay: $transition;
      opacity: 1;
    }
  }
  &_unbind {
    .social-btn-text__bind {
      opacity: 0;
    }
    .social-btn-text__unbind {
      opacity: 1;
      transition-delay: $transition;
    }
    .icon-google-logo {
      transform: translateX(79px);
    }
  }
}
.social-btn-text__bind {
  margin-left: -5px;
}
.phone-isnt-linked-text {
  @include font(12px, $red-color3);
}
.social-btn-wrap {
  position: relative;
}
.icon-google-logo {
  background-image: url("~src/assets/svg/google_red.svg");
  display: inline-block;
  vertical-align: middle;
  position: absolute;
  top: 19px;
  margin-left: 1px;
  width: 67px;
  height: 21px;
  transition: $transition;
  transition-delay: $transition/3;
}
.social-btn-text {
  @include font(16px, $red-color3);
  display: inline-block;
  transition: $transition;
  opacity: 0;
}
.delete-account-btn {
  max-width: 190px;
  padding: 11px 10px 10px 18px;
  .icon-lock {
    margin-left: -15px;
    margin-top: -1px;
  }
}

  .fade-enter-active {
    transition: opacity $transition/2;
  }
  .fade-enter, .fade-leave {
    opacity: 0;
  }

  @media only screen and (max-width : 1280px) {
    .background {
      padding: 10px 0 105px;
    }
    .settings-phone {
      width: 30%;
    }
    .settings__col {
      max-width: 320px;
    }
    .settings__selectbox {
      width: 320px;
    }
    .settings-email {
      max-width: 290px;
      width: 100%;
    }
    .change-password {
      @include incrSelectorWeight(1) {
        margin-left: 96px;
      }
    }
  }

  @media only screen and (max-width: 1023px) {
    .settings-email {
      max-width: 230px;
    }
    .change-password {
      @include incrSelectorWeight(2) {
        margin-left: 154px;
      }
    }
    .settings__email {
      max-width: 185px;
    }
    .settings-phone {
      width: 35%;
    }
  }

  @media only screen and (max-width: 940px) {
    .background {
      padding: 5px 5px 45px;
    }
    .settings-item {
      padding: 29px 0 0 27px;
      flex-direction: column;
      &__timezone {
        .settings__title {
          margin-bottom: 24px;
        }
      }
      &__email-overview {
        .settings {
          &__text {
            padding-right: 40px;
          }
          &__title {
            margin-bottom: 27px;
          }
          &__radio {
            margin-bottom: 13px;
          }
          &__column {
            padding-bottom: 40px;
          }
        }
      }
      &__delete-account {
        padding: 45px 0;
        .settings {
          &__title {
            display: none;
          }
        }
      }
    }
    .settings-email {
      margin-top: 24px;
      &__label {
        margin-bottom: 6px;
      }
    }
    .head-title {
      padding: 30px 28px;
    }
    .settings {
      &__column {
        width: 100%;
      }
      &__title {
        width: 100%;
      }
      .change-password {
        margin-left: 165px;
        margin-top: 25px;
      }
    }
    .delete-account-btn {
      display: block;
      margin: auto;
    }
  }
  @media only screen and (max-width: 740px) {
    .background {
      padding: 10px 5px 45px;
    }
    .head-title {
      padding: 31px 16px 26px;
    }
    .settings-item {
      padding: 41px 15px 0 15px;
      &__security {
        .settings {
          &__column {
            display: flex;
            flex-direction: column;
            .change-password {
              order: 1;
            }
          }
          &__checkbox {
            margin-top: 5px;
          }
        }
      }
      &__timezone {
        padding: 30px 15px 0 15px;
        .settings {
          &__column {
            display: flex;
            flex-direction: column;
            padding-bottom: 46px;
          }
          &__selectbox {
            max-width: 280px;
            margin-right: 0;
          }
          &__col {
            width: 100%;
            &:not(:first-child) {
              margin-left: 2px;
              margin-top: 27px;
            }
          }
          &__fiat-radios {
            margin-top: 41px;
            margin-left: 0px;
          }
        }
      }
      &__email-overview {
        padding: 30px 15px 0 13px;
        .settings {
          &__text {
            margin-left: 2px;
            padding-right: 0;
            line-height: 18px;
            font-size: 10px;
          }
          &__radio {
            margin-left: 3px;
          }
          &__column {
            padding-bottom: 37px;
          }
        }
        .settings-currencies {
          margin-top: 32px;
        }
      }
      &__delete-account {
        padding: 44px 15px;
      }
    }
    .settings-email,
    .settings-phone {
      width: 100%;
    }
    .change-password {
      @include incrSelectorWeight(2) {
        margin-left: 0;
        margin-top: 54px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/pages/settings/index.vue